import { AuthConstants } from "./auth-constants";
var AuthUtil = /** @class */ (function () {
    function AuthUtil() {
    }
    AuthUtil.armazenarToken = function (authToken) {
        localStorage.setItem(AuthConstants.ACCESS_TOKEN, authToken.access_token);
    };
    AuthUtil.armazenarUserName = function (username) {
        localStorage.setItem(AuthConstants.USER_NAME, username);
    };
    AuthUtil.getUserName = function () {
        return localStorage.getItem(AuthConstants.USER_NAME);
    };
    AuthUtil.getToken = function () {
        var _a;
        if (typeof window !== "undefined") {
            return (_a = localStorage.getItem(AuthConstants.ACCESS_TOKEN)) !== null && _a !== void 0 ? _a : "";
        }
        return "";
    };
    AuthUtil.deletarToken = function () {
        localStorage.removeItem(AuthConstants.ACCESS_TOKEN);
    };
    AuthUtil.getCpf = function () {
        return localStorage.getItem(AuthConstants.USER_CPF);
    };
    AuthUtil.DEVELOPMENT_LOCAL = process.env.REACT_APP_DEVELOPMENT_LOCAL;
    AuthUtil.BACK_END_URL = process.env.REACT_APP_BACKEND_ENDPOINT;
    return AuthUtil;
}());
export { AuthUtil };
